import React from "react";
import reactCSS from "reactcss";
import GlobalContextMenu from "./GlobalContextMenu.jsx";
import ToolTip from "../common/ToolTip";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import ColorPickerDot from "../color-picker/ColorPickerDot.js";

const Options = ({ children }) => {
    return (
        <>
            {children}
            <div className="tde-border-top tde-my-2"></div>
        </>
    );
};

class ContextMenuWrapper extends React.Component {
    static Options = Options;

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    keyPress = (e) => {
        if (e.key == "Escape") {
            this.props.handleClose();
        }
    };

    render = () => {
        const panel = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
        var pickerCss = {
            position: "fixed",
            zIndex: "999",
            overflow: "auto",
            boxShadow: "0px 3px 8px 3px rgba(0, 0, 0, 0.1)",
        };
        const bufferSpace = 10;
        const contextMenuWidth = this.props.contextMenuWidth;
        if (this.props.position.y > panel.height / 2) {
            pickerCss.bottom = panel.height - this.props.position.y + bufferSpace;
            pickerCss.maxHeight = panel.height - pickerCss.bottom - bufferSpace;
        } else {
            pickerCss.top = this.props.position.y + bufferSpace;
            pickerCss.maxHeight = panel.height - pickerCss.top - bufferSpace;
        }
        // To position the picker based on target element's position and available window width
        if(this.props.position.alignRight) {
            pickerCss.right = panel.width - this.props.position.x;
            const overflowingLeftPixels = this.props.position.x - contextMenuWidth;
            if(overflowingLeftPixels < 0) {
                pickerCss.right += overflowingLeftPixels - bufferSpace;
            } else {
                pickerCss.right += bufferSpace;
            }
        } else {
            pickerCss.left = this.props.position.x;
            const overflowingRightPixels = (pickerCss.left + contextMenuWidth) - panel.width;
            if(overflowingRightPixels > 0) {
                pickerCss.left -= overflowingRightPixels + bufferSpace;
            } else {
                pickerCss.left += bufferSpace;
            }
        }
        const styles = reactCSS({
            default: {
                picker: pickerCss,
                cover: {
                    position: "fixed",
                    top: "0px",
                    right: "0px",
                    bottom: "0px",
                    left: "0px",
                    zIndex: "999",
                },
            },
        });

        let { Dyn, isShowSquaresOnLinesEnable } = this.props;

        return (
            <div>
                <div style={styles.cover} onClick={this.props.handleClose} />
                <div
                    className="tde-std-dev-overlay"
                    style={styles.picker}
                    onKeyDown={this.keyPress}
                >
                    {!this.props.isColorPickerEnable && (
                        <div className="tde-p-2 tde-mx-1 tde-d-flex tde-flex-items-center tde-justify-space-between">
                            <label className="text-normal">
                                { this.getLoc("Color") }
                            </label>
                             <ColorPickerDot color={this.props.colorHex}
                                colorsArray={this.props.colorsArray}
                                onChange={this.props.handleChange}
                                Dyn={Dyn} />
                        </div>
                    )}
                    {!Dyn.plotUtil.isTuvaJr() && isShowSquaresOnLinesEnable && (
                        <>
                            <div className="tde-p-1">
                                <div className="tde-m-2 tde-d-flex tde-flex-items-center tde-justify-space-between ">
                                    <label className="text-normal">
                                        <span className="flex-1">
                                            {this.getLoc("Show Squares")}
                                            <ToolTip
                                                tip={this.getLoc(
                                                    "Display the squared residuals"
                                                )}
                                                Dyn={Dyn}
                                            >
                                                <i className="tde-i tde-i-exclamation tde-pl-2"></i>
                                            </ToolTip>
                                        </span>
                                    </label>
                                    <Toggle
                                        aria-label={this.getLoc("Show Squares")}
                                        checked={
                                            Dyn.plotView.plotShaper
                                                .showSquaresOnLines
                                        }
                                        id="tde-global-show-square-toggle"
                                        className="black-toggle"
                                        icons={false}
                                        onChange={(e) => {
                                            if (Dyn.plotView.plotShaper) {
                                                Dyn.mediator.publish( "plot:updateAdornment", { toggleShowSquaresOnLines: true });
                                            }
                                            this.setState({});
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="tde-border-top tde-my-1"></div>
                        </>
                    )}
                    {this.props.children}
                    <GlobalContextMenu getLoc={this.getLoc} Dyn={Dyn} />
                </div>
            </div>
        );
    };
}

export default ContextMenuWrapper;
